var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 23,
    viewBox: "0 0 28 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uicons-01-round-medium-cart 1",
    clipPath: "url(#clip0_175_16256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.6582 5.5H20.2121C21.1957 5.5 21.9131 6.43079 21.6626 7.38198L20.4776 11.882C20.3041 12.5408 19.7084 13 19.0271 13H7.9082",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.4082 2H3.53728C4.20201 2 4.78746 2.43749 4.97581 3.07498L7.65778 12.1524C7.82125 12.7057 7.82171 13.2944 7.65911 13.848L6.7332 17H17.6582",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.6582 21C7.76277 21 8.6582 20.1046 8.6582 19C8.6582 17.8954 7.76277 17 6.6582 17C5.55363 17 4.6582 17.8954 4.6582 19C4.6582 20.1046 5.55363 21 6.6582 21Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.6582 21C18.7628 21 19.6582 20.1046 19.6582 19C19.6582 17.8954 18.7628 17 17.6582 17C16.5536 17 15.6582 17.8954 15.6582 19C15.6582 20.1046 16.5536 21 17.6582 21Z",
    stroke: "white",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_175_16256"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 23,
    fill: "white",
    transform: "translate(0.658203)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shopping_cart.cfc66b5461aa9a97abd9e3b0cd88cc32.svg";
export { ForwardRef as ReactComponent };